import type { ThemeSlots } from "../../types";

/**
 * Default theme slot map. Empty for Phase 1 — the existing components under
 * src/app/components/ remain the built-in implementations and serve as the
 * fallback for every slot.
 */
export const slots: ThemeSlots = {};
